import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.extend(localizedFormat)

export function ConvertDateToLocal(date: string) {
    return dayjs(date).format('MM-DD-YYYY')
}

export function ConvertDate(date: string) {
    if (!date) return '' //'[Blank]'
    return dayjs(date).format('MM-DD-YYYY')
}

export function DaysBetweenDates(date1: string, date2: string) {
    if (!date1 || !date2) return 9999999999
    return dayjs(date2).diff(dayjs(date1), 'day')
}

export function DaysTilDate(date: string) {
    if (!date) return 9999999999
    return dayjs(date).diff(dayjs(), 'day')
}

export function ConvertDateForDB(date: string) {
    return dayjs(date).format('YYYY-MM-DD')
}

export function ConvertDateForWidget(date: string) {
    if (!date) return ''
    return dayjs(date).format('YYYY/MM/DD')
}

export function ConvertDateForDBOn(date: string | Date | dayjs.Dayjs) {
    return dayjs(date).format('YYYY-MM-DD')
}

export function Today() {
    return dayjs().format('MM-DD-YYYY') ?? ''
}

export function WeekFromToday() {
    return dayjs().add(7, 'day').format('MM-DD-YYYY') ?? ''
}

export function Yesterday() {
    return dayjs().subtract(1, 'day').format('MM-DD-YYYY') ?? ''
}

export function TodayDB() {
    return dayjs().format('YYYY-MM-DD') ?? ''
}

export function Now() {
    return dayjs().format('LTS') ?? ''
}

export function NowDB() {
    return dayjs().format('YYYY-MM-DD HH:mm:ss') ?? ''
}

export function ConvertDateTime(date: string) {
    return dayjs(date).format('MM-DD-YYYY hh:mm a')
}

export function ConvertDateTimeForDB(date: string) {
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
}

export function ConvertDateTimeToUTC(date: string) {
    const d = dayjs(date)
    return d.isValid() ? d.toISOString() : null
}

export function ConvertDateTimeDBToUTC(date: string) {
    const d = dayjs(date, 'YYYY-MM-DD HH:mm')
    return d.isValid() ? d.toISOString() : null
}

export function FormatToMoney(value: string, cents: number = 2) {
    return !value ? "" : Number(value.replace(/[^\d.-]/g, '')).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: cents, maximumFractionDigits: cents})
}

export function MoneyToNumeral(value: string) {
    return !value ? 0 : Number(value.replace(/[^\d.-]/g, ''))
}

export function NumeralToMoney(value: Number) {
    return !value ? '$0' : value.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2})
}

export function CheckString(value: string) {
    return value ? value : '[Blank]'
}